module.exports = "./img/f28a06ef8e9a650cc872aec4d8bdf9d9.jpg";